"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ExpressionType;

(function (ExpressionType) {
  ExpressionType["Aggregate"] = "aggregate";
  ExpressionType["Existence"] = "existence";
  ExpressionType["Named"] = "named";
  ExpressionType["Operator"] = "operator";
  ExpressionType["SpecialOperator"] = "specialOperator";
  ExpressionType["Term"] = "term";
  ExpressionType["Variable"] = "variable";
})(ExpressionType = exports.ExpressionType || (exports.ExpressionType = {}));